import React, { Component } from "react";
import { yearOptions } from "../config";
import { getTableConfig } from "./config";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleUploadImage from "../../../../../modules/upload/SimpleUploadImage";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import * as R from "ramda";
import { service } from "./service";
import CardBartChart from "../../../../../cards/SimpleBarchart";
import moment from "moment";
class FincoyCompositionReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: null,
      tableConfig: [],
      dataTable: [],
      chartVisible: false,
      showVolume: true,
      dataChart: [],
      dataPercentage: [],
      dataKey: [],
      chartPercentage: "",
      chartVolume: "",
    };
  }

  tableConfigMtd = () => {
    return [
      { name: "leasingName", label: "\n", options: { sort: false } },
      ...getTableConfig(this.props.tab),
      {
        name: "totalSalesInYear",
        label: this.state.year?.value || moment().format("YYYY"),
        options: { sort: false },
      },
    ];
  };

  tableConfigL3Y = () => {
    return [
      { name: "leasingName", label: "\n", options: { sort: false } },
      ...getTableConfig(this.props.tab, this.state.year?.value),
    ];
  };

  componentDidMount = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      year: yearOptions.find((item) => item.value === new Date().getFullYear()),
      tableConfig:
        this.props.tab === "mtd"
          ? this.tableConfigMtd()
          : this.tableConfigL3Y(),
    }));
  };

  componentDidUpdate(prevProps, prevState) {
    if (!R.equals(this.props.search, prevProps.search)) {
      this.fetchData();
    }
  }

  handleSearch = () => {
    this.setState({
      tableConfig:
        this.props.tab === "mtd"
          ? this.tableConfigMtd()
          : this.tableConfigL3Y(),
    }, () => this.fetchData())
  };

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleChartVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      chartVisible: !prevValue.chartVisible,
    }));
  };

  handleChangeChart = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      showVolume: !prevValue.showVolume,
    }));
  };

  transformLast3YearResponse = (data) => {
    return data.map((item) => {
      const { dataQuartal = {}, ...rest } = item;
      return {
        ...rest,
        ...dataQuartal,
      };
    });
  };
  transformMTDResponse = (data) => {
    return data.map((item) => {
      const { dataMonthlyLeasing = {}, ...rest } = item;
      return {
        ...rest,
        ...dataMonthlyLeasing,
      };
    });
  };

  fetchData = async () => {
    const { tab } = this.props;
    this.props.handleTriggerLoading();
    let dataKodeCabang = this.props.search;
    if (this.props.isAllSelected) {
      dataKodeCabang = this.props.dataCabang.map((item) => item.kodeCabang);
    }
    const asyncFn =
      this.props.tab === "mtd"
        ? Api.create("NAGAMAS_REPORT_DTO").getLaporanKomposisiFincoyYTD
        : Api.create("NAGAMAS_REPORT_DTO")
            .getLaporanKomposisiFincoyTigaTahunTerakhir;
    const res = await fetchDataAsync({
      asyncFn: asyncFn,
      setError: this.props.setError,
      menuName:
        "Dashboard Level Kepala Cabang Keatas - Laporan Sales Composition",
      args: {
        kodeCabang: dataKodeCabang,
        year: this.state.year?.value,
        employeeIdTeamLeader: this.props.idLeader,
      },
    });
    this.props.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const transformFunction =
        tab === "mtd"
          ? this.transformMTDResponse
          : this.transformLast3YearResponse;
      const transformed = transformFunction(res.data.data);
      
      const parseDataChartFunction =
        tab === "mtd"
          ? service.parseDataChartYearToDate
          : service.parseDataChartLast3Year;
          
      const dataChart = parseDataChartFunction(transformed, true, this.state.year?.value);
      const dataPercentage = parseDataChartFunction(transformed, false, this.state.year?.value);
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: transformed,
        dataKey: service.parseDataKey(transformed),
        dataChart,
        dataPercentage,
      }));
    }
  };

  render() {
    const { showVolume, dataChart, dataKey, dataPercentage } = this.state;
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            isClearable
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        {!this.state.chartVisible && (
          <SimpleDataTable
            data={this.state.dataTable}
            columns={this.state.tableConfig}
          />
        )}
        {/* {this.state.chartVisible && (
                    <SimpleUploadImage
                        label={this.state.chartVisible}
                        category=""
                        id="input_photo_chart"
                        name="chart"
                        value={this.state.showVolume ? this.state.chartVolume : this.state.chartPercentage}
                    />
                )} */}
        {this.state.chartVisible && (
          <div>
            <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
              Chart By {showVolume ? "Volume" : "Percentage"}
            </p>
            {showVolume && <CardBartChart data={dataChart} dataKey={dataKey} />}
            {!showVolume && (
              <CardBartChart data={dataPercentage} dataKey={dataKey} yAxisType="percentage" />
            )}
          </div>
        )}
        <FlexView style={{ justifyContent: "end", marginTop: "15px" }}>
          <SimpleButton onClick={this.handleChartVisibility}>
            Chart
          </SimpleButton>
          {this.state.chartVisible && (
            <SimpleButton
              onClick={this.handleChangeChart}
            >{`Percentage /\n Volume`}</SimpleButton>
          )}
        </FlexView>
      </>
    );
  }
}

export default FincoyCompositionReport;
